
<marv-section-title label="{{'OPERATIONAL_PHOTOS' | translate}}" />
<marv-toggle label="{{'SKIP_PRESENCE_CHECK' | translate}}" labelPlacement="end" formName="skipPresenceCheck"/>
<marv-toggle label="{{'SKIP_DRAC' | translate}}" labelPlacement="end" formName="skipDrac"/>

@if(this.isFetching){
    <div class="bloc_loading">
        <ion-spinner></ion-spinner>
    </div>        
}
@else{

    @for(opFilter of this.operationFilters | keyvalue; track opFilter.key){
        @if((opFilter.value.filters.photoTagCriteriaChunks && opFilter.value.filters.photoTagCriteriaChunks.length > 0)
            || (opFilter.value.filters.isaReportDataModelGroups && opFilter.value.filters.isaReportDataModelGroups.length > 0)
            || (opFilter.value.filters.productDataModelsChunks && opFilter.value.filters.productDataModelsChunks.length > 0) ){
            <div 
                class="operation_filters"
                [class.open]="opFilter.value.open"
                >
                <div class="operation_filters_name" (click)="this.toogleOperationFilters(opFilter.value)">
                    {{opFilter.value.operation.name}}
                    <ion-icon [name]="(opFilter.value.open ? 'chevron-up-outline' : 'chevron-down-outline')" ></ion-icon> 
                </div>
                <div 
                    class="photo_search_criterias"                    
                    >
                    @if(opFilter.value.filters.photoTagCriteriaChunks && opFilter.value.filters.photoTagCriteriaChunks.length > 0){
                        <div class="filter_title">
                            <marv-section-title label="{{'VISIT_PHOTOS' | translate}}" />
                            <marv-button 
                                [icon]="(this.photoTagAllChecked.get(opFilter.key) === true ? 'square-outline' : 'checkbox-outline')" 
                                [rounded]="true" 
                                [disabled]="this.formGroupDirective.form.controls['anima_enableTaggedPictures_'+opFilter.key].value === false"
                                size="small" 
                                (click)="this.toggleCheckVisitPhotos(opFilter.key, opFilter.value.filters.photoTagCriteriaChunks)" 
                                />  
                            <marv-toggle 
                                [formName]="'anima_enableTaggedPictures_'+opFilter.key" 
                                [noMargin]="true"
                                />
                        </div>
                        <div class="checkbox_filters">
                            @for(rows of opFilter.value.filters.photoTagCriteriaChunks; track $index){
                                @for(tag of rows; track $index){
                                    <marv-checkbox 
                                        [label]="tag.title" 
                                        [formName]="'anima_photoTag_'+opFilter.key+'_'+tag.value" 
                                        [disabled]="this.formGroupDirective.form.controls['anima_enableTaggedPictures_'+opFilter.key].value === false" 
                                        labelPlacement="end"
                                        /> 
                                }
                            }
                        </div>
                    }

                    @if(opFilter.value.filters.isaReportDataModelGroups && opFilter.value.filters.isaReportDataModelGroups.length > 0){
                        <div class="filter_title">
                            <marv-section-title label="{{'QUESTIONS_PHOTOS' | translate}}" />
                            <marv-button 
                                [icon]="(this.isaReportPicturesAllChecked.get(opFilter.key) === true ? 'square-outline' : 'checkbox-outline')" 
                                [rounded]="true" 
                                [disabled]="this.formGroupDirective.form.controls['anima_enableIsaReportPictures_'+opFilter.key].value === false"
                                size="small" 
                                (click)="this.toggleCheckIsaReportPictures(opFilter.key, opFilter.value.filters.isaReportDataModelGroups)" 
                                />  
                            <marv-toggle 
                                [formName]="'anima_enableIsaReportPictures_'+opFilter.key" 
                                [noMargin]="true"
                                />
                        </div>
                        @for(group of opFilter.value.filters.isaReportDataModelGroups; track $index){
                            <div class="sub_items_filters with_padding_left">
                                <marv-sub-item>
                                    <div class="sub_item_filter_title">
                                        {{group.name}}
                                        <div class="button_toggle_check">
                                            <marv-button 
                                                [icon]="(this.isaReportGroupAllChecked.get(opFilter.key+'_'+group.id) === true ? 'square-outline' : 'checkbox-outline')" 
                                                [rounded]="true" 
                                                [disabled]="this.formGroupDirective.form.controls['anima_enableIsaReportPictures_'+opFilter.key].value === false"
                                                size="small" 
                                                (click)="this.toggleCheckIsaReportGroup(opFilter.key, group.id, group.isaReportDataModelChunks)" 
                                                />
                                        </div>
                                    </div>
                                    <div class="checkbox_filters">
                                        @for(rows of group.isaReportDataModelChunks; track $index){
                                            @for(question of rows; track $index){
                                                <marv-checkbox 
                                                    [label]="question.name" 
                                                    [formName]="'anima_photoQuestion_'+opFilter.key+'_'+question.id" 
                                                    [disabled]="this.formGroupDirective.form.controls['anima_enableIsaReportPictures_'+opFilter.key].value === false" 
                                                    labelPlacement="end"
                                                    /> 
                                            }
                                        }
                                    </div>
                                </marv-sub-item>
                            </div>
                        }                
                    }

                    @if(opFilter.value.filters.productDataModelsChunks && opFilter.value.filters.productDataModelsChunks.length > 0){
                        <div class="filter_title">
                            <marv-section-title label="{{'PRODUCTS_QUESTIONNAIRE' | translate}}" />                      
                            <marv-toggle 
                                [formName]="'anima_enableProductPictures_'+opFilter.key" 
                                [noMargin]="true"
                                />                
                        </div>    

                         <marv-item>
                            <div class="item_filter_title">
                                {{'QUESTIONS' | translate}}
                                <div class="button_toggle_check">
                                    <marv-button 
                                        [icon]="(this.photoProductQuestionAllChecked.get(opFilter.key) === true ? 'square-outline' : 'checkbox-outline')" 
                                        [rounded]="true" 
                                        [disabled]="this.formGroupDirective.form.controls['anima_enableProductPictures_'+opFilter.key].value === false"
                                        size="small" 
                                        (click)="this.toggleCheckPhotoProductQuestion(opFilter.key, opFilter.value.filters.productDataModelsChunks)" 
                                        />
                                </div>
                            </div>

                            <div class="checkbox_filters">
                                @for(rows of opFilter.value.filters.productDataModelsChunks; track $index){
                                    @for(question of rows; track $index){
                                        <marv-checkbox 
                                            [label]="question.title" 
                                            [formName]="'anima_photoProductQuestion_'+opFilter.key+'_'+question.value" 
                                            [disabled]="this.formGroupDirective.form.controls['anima_enableProductPictures_'+opFilter.key].value === false"
                                            labelPlacement="end"
                                            /> 
                                    }
                                }
                            </div>
                        </marv-item>

                        @if(opFilter.value.filters.productCategories && opFilter.value.filters.productCategories.length > 0){ 

                            <marv-item>
                               <div class="item_filter_title">
                                    {{'PRODUCTS' | translate}}
                                    <div class="button_toggle_check">
                                        <marv-button 
                                            [icon]="(this.photoQuestionAllChecked.get(opFilter.key) === true ? 'square-outline' : 'checkbox-outline')" 
                                            [rounded]="true" 
                                            [disabled]="this.formGroupDirective.form.controls['anima_enableProductPictures_'+opFilter.key].value === false"
                                            size="small" 
                                            (click)="this.toggleCheckPhotoQuestion(opFilter.key, opFilter.value.filters.productCategories)" 
                                            />
                                    </div>
                               </div>

                                @for(category of opFilter.value.filters.productCategories; track $index){
                                    <div class="sub_items_filters">
                                        <marv-sub-item>
                                            <div class="sub_item_filter_title category_title">
                                                {{category.name}}
                                                <div class="button_toggle_check">
                                                    <marv-button 
                                                        [icon]="(this.productCategoryAllChecked.get(opFilter.key+'_'+category.id) === true ? 'square-outline' : 'checkbox-outline')" 
                                                        [rounded]="true" 
                                                        [disabled]="this.formGroupDirective.form.controls['anima_enableProductPictures_'+opFilter.key].value === false"
                                                        size="small" 
                                                        (click)="this.toggleCheckProductCategory(opFilter.key, category.id, category.ranges)" 
                                                        />
                                                </div>
                                            </div>

                                            @for(range of category.ranges; track $index){
                                                <marv-sub-item>
                                                    <div class="sub_item_filter_title">
                                                        {{range.name}}
                                                        <div class="button_toggle_check">
                                                            <marv-button 
                                                                [icon]="(this.productRangeAllChecked.get(opFilter.key+'_'+range.id) === true ? 'square-outline' : 'checkbox-outline')" 
                                                                [rounded]="true" 
                                                                [disabled]="this.formGroupDirective.form.controls['anima_enableProductPictures_'+opFilter.key].value === false"
                                                                size="small" 
                                                                (click)="this.toggleCheckProductRange(opFilter.key, range.id, range.productChunks)" 
                                                                />
                                                        </div>
                                                    </div>
                                                    <div class="checkbox_filters">
                                                        @for(rows of range.productChunks; track $index){
                                                            @for(product of rows; track $index){
                                                                <marv-checkbox 
                                                                    [label]="product.name" 
                                                                    [formName]="'anima_photoProduct_'+opFilter.key+'_'+product.id" 
                                                                    [disabled]="this.formGroupDirective.form.controls['anima_enableProductPictures_'+opFilter.key].value === false"
                                                                    labelPlacement="end"
                                                                    /> 
                                                            }
                                                        }
                                                    </div>
                                                </marv-sub-item>
                                            }

                                        </marv-sub-item>
                                    </div>
                                }
                            </marv-item>
                        }

                    }                

                </div>

            </div>
        }
    }
}